import { NgModule } from '@angular/core';
import { AccessCodeAddStore } from '@spaq/core/stores/access-code-add-store';
import { AccessCodeDetailsStore } from '@spaq/core/stores/access-code-details-store';
import { ProfileDetailsStore } from '@spaq/core/stores/profile-details-store';
import { ProfileEditStore } from '@spaq/core/stores/profile-edit-store';
import { ProfileStore } from '@spaq/core/stores/profile-store';
import { SubscriptionDetailsStore } from '@spaq/core/stores/subscription-details-store';
import { SubscriptionEditStore } from '@spaq/core/stores/subscription-edit-store';
import { SubscriptionStore } from '@spaq/core/stores/subscription-store';

@NgModule({
	imports: [],
	declarations: [],
	providers: [
		ProfileStore,
		ProfileEditStore,
		ProfileDetailsStore,
		SubscriptionStore,
		SubscriptionEditStore,
		SubscriptionDetailsStore,
		AccessCodeAddStore,
		AccessCodeDetailsStore
	]
})
export class StoresModule {}
